<template>
    <div>
        <v-dialog v-model="showModal"  max-width="400" persistent>
            <v-card>
                <v-card-title class="text-h6 d-flex justify-space-between">
                    Atención
                    <v-btn icon @click="$emit('cerrar')">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    Debes subir el archivo antes de seleccionar otro documento. Da click en "Subir archivo".
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="$emit('cerrar')">
                        Entendido
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showModal: true,
        };
    },
    methods: {
        // uploadFile() {
        //     // Logic to handle file upload
        //     console.log("Subir archivo clicked");
        //     this.dialog = false;
        // },
    },
};
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>